<template>
    <md-card style="margin-top: 40px;">
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
                <font-awesome-icon class="md-icon" :icon="['fa', 'info']"/>
            </div>
            <h4 class="title">Information de l'intervention</h4>
        </md-card-header>
        <md-card-content>
            <div>
                <span class="font-bold">Type de prestation : </span>
                {{ intervention.category.name }} {{ intervention.planning_intervention_prevision ? '(contrat)' : '(ponctuel)' }}
            </div>
            <div>
                <span class="font-bold">Type d'intervention : </span>
                {{ intervention.intervention_type.name }} ({{ intervention.intervention_type.id }})
            </div>
	        <div class="flex items-center space-x-4">
		        <md-field class="md-invalid">
			        <label class="font-bold">Commentaire</label>
			        <md-textarea v-model="intervention.comment" name="comment" md-autogrow></md-textarea>
		        </md-field>
		        <md-button class="md-icon-button md-success" @click="updateComment">
			        <font-awesome-icon class="md-icon" :icon="['fa', 'save']"/>
		        </md-button>
	        </div>
	        <md-divider class="mb-3 mt-2 -mx-5"></md-divider>
	        <div>
		        <span class="font-medium">Suppression de l'intervention</span>
		        <form @submit.prevent="deleteIntervention">
			        <div class="flex items-center space-x-4">
				        <md-field class="md-invalid">
					        <label class="font-bold">Raison</label>
					        <md-textarea v-model="reason" name="reason" md-autogrow required></md-textarea>
				        </md-field>
				        <md-button class="md-icon-button md-danger" type="submit" :disabled="isDeleting">
					        <font-awesome-icon class="md-icon" :class="{ 'animate-spin': isDeleting }" :icon="['fa', isDeleting ? 'sync-alt' : 'times-circle']"/>
				        </md-button>
			        </div>
		        </form>
	        </div>
        </md-card-content>
    </md-card>
</template>

<script>
export default {
    name: "Information",
    props: {
        intervention: {
            type: Object
        }
    },
    data(){
        return {
            isDeleting: false,
            reason: "",
        }
    },
    methods: {
        async updateComment() {
            try {
                await this.$store.dispatch('interventions/updateInterventionComment', {
                    id: this.intervention.id,
                    comment: this.intervention.comment,
                })
                await this.$store.dispatch('alerts/success', 'Le commentaire a bien été mis à jour')
            } catch (e) {}
        },
        async deleteIntervention() {
			this.isDeleting = true
	        try {
		        await this.$store.dispatch('interventions/deleteIntervention', {
			        id: this.intervention.id,
			        reason: this.reason,
		        })
		        await this.$store.dispatch('alerts/success', 'L\'intervention a bien été supprimée')
		        await this.$router.push({ name: 'Interventions' })
	        } catch (e) {
		        this.isDeleting = false
	        }
        }
    }
}
</script>

<style scoped>

</style>
